// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--yaQKR";
export var header = "styles-module--header--9ImTn";
export var firstPost = "styles-module--first-post--1NDZ5";
export var featured = "styles-module--featured--P+ODm";
export var list = "styles-module--list--botJG";